module.exports = __webpack_public_path__ + "static/img/qrcode.2bf4e66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/qrcode.png
// module id = My/P
// module chunks = 62